// extracted by mini-css-extract-plugin
export default {"content":"a6Z1Q1uFqN56vDcpk5WA"};